module.exports = __webpack_public_path__ + "img/istj-selected.783de353.png";